<div class="input" [ngClass]="{
        'input-error': hasError,
        touched: focused || hasValue
      }">
    <div class="input-header">
        <label [for]="inputId()">{{ label() | upperFirstLetter }}
            @if (inputFormControl().hasValidator(validatorsRequired)) {
            <span class="required">*</span>
            }
        </label>
    </div>

    @if(inputFormControl()){
    <input type="text" [id]="inputId()" [formControl]="inputFormControl()" (focus)="focused = true" (blur)="onBlur()"
        [ngStyle]="{right: tooltip() ? '44px' : '12px'}" [name]="inputId()" />
    } @else {
    <input type="text" [id]="inputId()" (focus)="focused = true" (blur)="onBlur()"
        [ngStyle]="{right: tooltip() ? '44px' : '12px'}" />
    }

    @if(tooltip()){
    <kin-icon name="information" [size]="18" color="#000000" [tooltip]="tooltip()!" [tooltipDelay]="200"
        [tooltipPosition]="'top'" [tooltipDuration]="5000" />
    }
</div>

@if (hasError && getErrorMessage()) {
<p class="field-error">{{ getErrorMessage() }}</p>
} @else if(showCounter() && inputValueLength >= counterThreshold) {
<p class="field-error counter">{{inputValueLength}}/{{maxlength()}}</p>
}